import React from 'react'
import Navbar from '../defaultComponents/Navbar'
import Footer from '../defaultComponents/Footer'

import { Button } from '@mui/material'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import {
  useNavigate
} from 'react-router-dom'

import PDFViewer from '../dropbox/PDFViewer';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export default function AllFormsPage() {

  const [formsList, setFormsList] = React.useState([])
  const [pdfBuffer, setPDFBuffer] = React.useState(null)

  const navigate = useNavigate()

  const getFormsList = async () => {
    try {
      const response = await fetch("https://ic360portalbackend.azurewebsites.net/api/Dropbox/allForms/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })

      const listData = await response.json()
      setFormsList(listData)
    } catch (error) {
    }
  }

  const handleFormRender = async (path) => {
    try {
      const response = await fetch("https://ic360portalbackend.azurewebsites.net/api/Dropbox/singleFormDownload", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          path: path,
        })
      })

      const data = await response.arrayBuffer();
      const dataUint8 = await new Uint8Array(data);

      await setPDFBuffer(dataUint8)
    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(()=>{
    getFormsList()
  },[])

  // For exporting files
  const [selectedForm, setSelectedForm] = React.useState(null)
  const handleExport = () => {
    const blob = new Blob([pdfBuffer], {type: "application/pdf"});

    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a")
    link.href = objectUrl;
    link.download = `${selectedForm}.pdf`
    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
  }

  // Only load export button after pdf has loaded
  // also helps control style/rendering of loading

  const containerRef = React.useRef(null); // keep track of current container
  const successCallback = () => {
    if (containerRef.current) {
      containerRef.current.classList.add('loaded');
    }
  }

  // When pdf buffer changes, update the pdf-viewer-container
  React.useEffect(()=> {
    if(containerRef.current) {
      containerRef.current.classList.remove('loaded');
    }
  }, [pdfBuffer])

  return (
    <>
      <Navbar />
      <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
        <div className="default-page-wrapper">
          <div className ="page-buttons-bar page-buttons-bar-parent">
            <Button sx ={{color: "white"}} onClick={()=>{navigate('/')}}> <ArrowBackOutlinedIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> back</Button>
          </div>
          <div className ="page-buttons-bar">
            <div className='page-buttons-bar-subtitle'>IC360 Forms and Policies</div>
          </div>
          <div className ="page-buttons-bar">
            <div className="page-function-buttons-container">
              {formsList.map((formInfo, idx) => {
                return <Button 
                sx ={{color: "white"}}
                onClick={()=>{
                  handleFormRender(formInfo.path_display)
                  setSelectedForm(formInfo.name)
                }}
                > 
                  <DescriptionIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> 
                  {formInfo.name}
                </Button>
              })}
            </div>
          </div>
          <div ref = {containerRef} className="pdf-viewer-container hidden" style={{background: "white"}}>
          {
            pdfBuffer && 
            <>
            <div className="" style={{flex: "1", width: "100%"}}>
              <Button 
                sx={{
                  float: "right",
                  marginRight: "1vw",
                  background: "#4CAF50",
                  color: "white",
                  border: "1px solid #4CAF50",
                  "&:hover": {
                    background: "#43A047",
                    color: "white",
                  }
                }}
                onClick = {()=>{handleExport()}}
              >
                <FileDownloadIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> Export
              </Button>
            </div>

              <PDFViewer pdfBuffer={pdfBuffer} successCallback = {successCallback}/>
            </>
          }
          </div>

        </div>
      <Footer />
      </div>
    </>
  )
}
